import { combineReducers } from 'redux';
import FilterStore from './filterstore';


const allReducers = combineReducers({
    filterStore: FilterStore,
});

export default allReducers;
